import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PackageService } from '../services/package.service';
import { UserService } from '../services/user.service';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'app-my-packages',
  templateUrl: './my-packages.component.html',
  styleUrls: ['./my-packages.component.scss']
})
export class MyPackagesComponent {
  @Output() close = new EventEmitter();
  @Input() packageApptRefNum: any;
  @Input() ordersetId: any;
  @Input() packageInfo: any;
  @Input() modalId: string;
  linkedPatients: any;
  selectedTab: string;
  packageList: any[];
  healthPackages: any;
  tabs = PACKAGETABS;
  selectedPackage: any;
  constructor(private packageService:PackageService, private user:UserService, private modalService: ModalService,) {
    this.user?.setIsFromPackage(false);
  }

  ngOnInit() {
    console.log('ordersetId', this.ordersetId, 'packageInfo', this.packageInfo);
    this.user.getUserInfo('linkedPatients').subscribe(patients => {
      this.linkedPatients = patients
      const data = this.user.getUpdateInfoSync('directives');
      if (data && data.userDefined) {
        this.healthPackages = data.userDefined.find(def => def.directiveGroup == 'HOSPSERV')
        if (this.packageApptRefNum || this.ordersetId) {
          this.user.setApptConfirmationDetails(null);
          this.autoSelectPackageTab();
        } else {
          this.changeActiveTab(this.tabs[0]);
        }
      };
    });
    // if(this.packageApptRefNum)

  }

  getAllPackages() {
    let inparam={
      "patientIds":this.linkedPatients.map(p => p['uhid']),
    }

    this.packageService.getPackages(inparam).subscribe(data => {
    })
  }

public autoSelectPackageTab() {
  let inparam = {
    patientIds: this.linkedPatients.map(p => p['uhid']),
    status: 'A'
  };

  this.packageService.getPackages(inparam).subscribe(data => {
    const target = data.find(pkg => pkg?.appointment_id == this.packageApptRefNum || pkg?.orderSetId == this.ordersetId);
    if (!target) {
      this.changeActiveTab(this.tabs[0]);
      return;
    }
    const statusMapping = {
      "Ordered": "UPCOMING",
      "In Progress": "UPCOMING",
      "Resulted - Complete": "COMPLETED",
      "Cancelled": "CALNCELLED"
    };
    const correctTabId = statusMapping[target.status];
    const tab = this.tabs.find(t => t.id === correctTabId);
    if (tab) {
      this.changeActiveTab(tab);
    }
  });
}


  public changeActiveTab(tab) {
    if (!tab) {
      console.error("Invalid tab passed", tab);
      return;
    }
    this.selectedTab = tab['id'];

    //Mock data - for dev purpose
    // this.packageList = pkg
    this.packageList=[]
    if(this.selectedTab=='CALNCELLED')
      this.getActivePackages('X')
    else if(this.selectedTab=='COMPLETED')
      this.getActivePackages('C')
    else if(this.selectedTab=='UPCOMING')
      this.getActivePackages('A') 
  }
  public getActivePackages(status){
    let inparam={
      "patientIds":this.linkedPatients.map(p => p['uhid']),
      "status":status

    }
    this.packageService.getPackages(inparam).subscribe(data=>{
      let healthPackages = this.user.getAllPackageConcepts();
      data.map((p)=>{
        healthPackages.forEach((c)=>{
          if(p['packageCode']==c['code']){
            p['_healthPackage'] = c;
            p.packageInfo = p;
            p.packageStatusFromTab = status;
            if(c['detail'] && c['detail'].length>0){
              c['detail'].forEach((d)=>{
                if(d['locale']==this.user.getCurrentLanguage())
                  p['imageURL']=d['imageURL']
              })
            }
          }
        })
      })
      this.packageList=data;
      if(this.packageApptRefNum) {
        let selectedPkg = this.packageList.find(pkg => pkg?.appointment_id == this.packageApptRefNum);
        this.openPackageDetails(selectedPkg);
      } else if(this.ordersetId) {
        let selectedPkg = this.packageList.find(pkg => pkg?.orderSetId == this.ordersetId);
        this.openPackageDetails(selectedPkg);
      }
    })
  }
  
  public openPackageDetails(p) {
    this.selectedPackage = p;
    this.packageService.setValue('packageDetails', p);
  }

  closeModal() {
    if(this.modalId) this.modalService.close(this.modalId);
    else this.close.emit();
  }

  onClose(data) {
    if(data) {
      this.selectedPackage =  null
      this.closeModal();
    }else {
      this.selectedPackage =  null
    }
  }
}

export const PACKAGETABS = [
	{
	  id: "UPCOMING",
	  label:"Active",
	  permission:'ENABLEUPCOMING',
	  display:true
	},
	{
		id: "COMPLETED",
		label:"Completed",
		permission:'ENABLECOMPLETED',
		display:true
	}, 
	{
	  id: "CALNCELLED",
	  label:"Cancelled",
	  permission : 'ENABLECANCELLED',
	  display:true
	}
]